/**
 * Die v1-Screens und ihre Pfade (Architektur 05, Abschnitt Screens). Pfade
 * sind fest; Arbeitspaket 4 haengt hier seine Seiten ein. `rolle` = Mindestrolle.
 */
import type { Rolle } from '@storeos/contracts';

export interface Screen {
  pfad: string;
  name: string;
  rolle: Rolle;
  /** R127: auch für die Rolle produktion (B&B), die sonst keinen Screen sieht. */
  produktion?: boolean;
}

/** R127: Startseite der Rolle produktion nach dem Login. */
export const PRODUKTION_START = '/produktion/erfassen';

/** Sichtbare Screens einer Rolle: produktion nur die markierten, sonst nach Mindestrolle (Rang). */
export function sichtbareScreens(rolle: Rolle, rang: (r: Rolle) => number): Screen[] {
  return SCREENS.filter((s) => (rolle === 'produktion' ? s.produktion === true : rang(rolle) >= rang(s.rolle)));
}

export const SCREENS: readonly Screen[] = [
  { pfad: '/', name: 'Dashboard', rolle: 'lager' },
  { pfad: '/auftraege', name: 'Aufträge', rolle: 'lager' },
  { pfad: '/packstation', name: 'Packstation', rolle: 'lager' },
  { pfad: '/tagesabschluss', name: 'Tagesabschluss', rolle: 'lager' },
  { pfad: '/produktion', name: 'Produktion intern', rolle: 'lager' },
  { pfad: '/produktion/erfassen', name: 'Produktion erfassen', rolle: 'leitung', produktion: true },
  { pfad: '/artikel', name: 'Artikel / Lager', rolle: 'lager' },
  { pfad: '/wareneingang', name: 'Wareneingang', rolle: 'lager' },
  { pfad: '/inventur', name: 'Inventur', rolle: 'lager' },
  { pfad: '/retouren', name: 'Retouren', rolle: 'lager' },
  { pfad: '/belege', name: 'Belege', rolle: 'leitung' },
  { pfad: '/protokoll', name: 'Protokoll', rolle: 'leitung' },
  { pfad: '/einstellungen', name: 'Einstellungen', rolle: 'leitung' },
];
